import React from "react";
import { useNavigate } from "react-router-dom";
//styles
import styles from "./PersonalSpaceStyles.module.scss";
//mui
import { Grid2 } from "@mui/material";
//local import
import IconButton from "../../../../../../GlobalComponents/IconButton/IconButton";

//icons
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import { ReactComponent as Sites } from "../../../../../../GlobalAssets/svg/Sites.svg";
import { ReactComponent as CreateSiteSvg } from "../../../../../../GlobalAssets/svg/CreateSite.svg";
import { ReactComponent as SiteIcon } from "../../../../AdminAssets/svg/SiteIconBlue.svg";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import { ReactComponent as Usa } from "../../../../../../GlobalAssets/svg/UsaSvg.svg";
import { ReactComponent as Indian } from "../../../../../../GlobalAssets/svg/IndianSvg.svg";

function PersonalSpace(props) {
  const {
    name,
    plan,
    onClick,
    icon: Icon,
    userDetails,
    dedicatedHosting,
  } = props;

  const sites = plan?.featureDetails?.find(
    (feature) => feature.type === "NUM_SITES",
  );

  const navigate = useNavigate();
  const handleDashboard = (event) => {
    event.stopPropagation();
    navigate(`/account/${-1}/dashboard`);
  };
  const handleSites = (event) => {
    event.stopPropagation();
    navigate(`/account/${-1}/sites-overview`);
  };
  const handleCreateSite = (event) => {
    event.stopPropagation();
    navigate(`/account/${-1}/create`);
  };
  const handleBlueprints = (event) => {
    event.stopPropagation();
    navigate(`/account/${-1}/blueprints`);
  };
  const handleBilling = (event) => {
    event.stopPropagation();
    if (plan) {
      navigate(`/account/${-1}/billing-overview`);
    } else navigate(`/account/${-1}/modify-plan`);
  };

  const isPlanExpiredOrExpiring =
    plan?.daysAfterExpiry > 0 ||
    (plan?.daysAfterExpiry <= 0 && plan.daysAfterExpiry !== null);

  const isplan =
    (plan && dedicatedHosting === true) || (plan && dedicatedHosting === false);

  const isSingleSitePlan = plan?.isSingleSite;

  return (
    <Grid2
      className={`${styles.container} ${
        isPlanExpiredOrExpiring ? styles.expiry : ""
      }`}
      onClick={onClick}
    >
      <Grid2 className={styles.title}>My Space</Grid2>
      <Grid2
        className={`${styles.detailsContainer} ${
          isPlanExpiredOrExpiring ? styles.expiry : ""
        }`}
      >
        <Grid2 className={styles.iconContainer}>
          <Icon className={styles.Icon} />
        </Grid2>
        <Grid2>
          <Grid2 className={styles.flexBox}>
            <Grid2 className={styles.name}>{name}</Grid2>
            {process.env.REACT_APP_TEMP_DOMAIN === "rocondev.com" && (
              <Grid2 className={styles.countryBox}>
                {userDetails?.country === "USA" ? (
                  <Usa className={styles.country} />
                ) : (
                  <Indian className={styles.country} />
                )}
              </Grid2>
            )}
          </Grid2>
          <Grid2 className={styles.plan}>
            {sites?.used ? (
              <Grid2 className={styles.planContainer}>
                <Grid2>
                  <SiteIcon />
                </Grid2>
                <Grid2 className={styles.planName}>{sites?.used} Sites</Grid2>
              </Grid2>
            ) : (
              ""
            )}
            <Grid2 className={styles.planContainer}>
              <Grid2 className={styles.planText}>Plan :</Grid2>
              {plan ? (
                <Grid2
                  className={`${styles.planName} ${
                    isPlanExpiredOrExpiring ? styles.planExpried : ""
                  }`}
                >
                  {isPlanExpiredOrExpiring
                    ? "Plan Expired"
                    : `${plan?.isSingleSite === true ? "SS" : "MS"} - ${
                        plan?.licenseType
                      }`}
                  {process.env.REACT_APP_TEMP_DOMAIN === "rocondev.com" && (
                    <>
                      {isplan && (
                        <span
                          className={`${
                            dedicatedHosting === true
                              ? styles.isPlan
                              : styles.isPlan1
                          }`}
                        >
                          {dedicatedHosting === true
                            ? "Dedicated"
                            : "Kubernetes"}
                        </span>
                      )}
                    </>
                  )}
                </Grid2>
              ) : (
                <Grid2 className={styles.planName}>
                  You don't have any plan
                </Grid2>
              )}
            </Grid2>
          </Grid2>
          <Grid2
            className={`${styles.icons} ${
              isSingleSitePlan === true || dedicatedHosting
                ? styles.iconsGap
                : ""
            }`}
          >
            <IconButton
              icon={DashboardOutlinedIcon}
              tooltipText="Dashboard"
              onClick={handleDashboard}
            />
            <IconButton
              icon={CreateSiteSvg}
              tooltipText="Create site"
              onClick={handleCreateSite}
            />
            <IconButton
              icon={Sites}
              tooltipText="Sites"
              onClick={handleSites}
            />
            {/* blueprints copy v1 (EFS) storage; personal sites are built on v2 unless dedicated */}
            {!isSingleSitePlan && dedicatedHosting && (
              <IconButton
                icon={DrawOutlinedIcon}
                tooltipText="Blueprints"
                onClick={handleBlueprints}
              />
            )}
            <IconButton
              icon={PaidOutlinedIcon}
              tooltipText={plan ? "Billing" : "Plans"}
              onClick={handleBilling}
            />
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}

export default PersonalSpace;
